import React from 'react'
import appPath from '../../lib/appPath';
import {PowerSettingsNew, QuestionMark} from '@mui/icons-material'
import {IconButton, Tooltip} from '@mui/material'
import {useAuth} from 'react-oidc-context'

import {GAEventTracker} from '../../lib/googleAnalytics'
import {routeToLogin} from '../../lib/utils'
import {broadcastLogout, clearLocalSession, markLoggingOut} from '../../auth/sessionSync'

const AccountMenu = () => {
  const auth = useAuth();

  const openGuide = (event) => {
    event.stopPropagation()
    GAEventTracker({category: 'Show Guidelines', action: 'Click'})
    window.open(appPath('/guide'));
  }

  const logout = (event) => {
    event.stopPropagation()
    GAEventTracker({category: 'Sign Out', action: 'Click'})
    // Before anything touches storage: the other tabs tear down by clearing
    // the shared oidc.* keys, and those removals echo back as storage events
    // in THIS tab. Without this marker we'd read our own logout as someone
    // else's, flag this tab signed-out and fire a navigation that races the
    // signoutRedirect below. See sessionSync.markLoggingOut.
    markLoggingOut()
    // Tell the other tabs FIRST: they share this token, so they must not keep
    // rendering a signed-in UI while Zitadel tears the session down. Sending
    // it before the redirect means they react even if the redirect stalls.
    broadcastLogout()
    // Impersonation keys, legacy cookies and the shared app profile
    clearLocalSession()
    // Use OIDC signout to end session at Zitadel (prevents auto-re-login).
    // signoutRedirect() also removes the shared OIDC user, which is the
    // second signal the other tabs listen for.
    if (auth.isAuthenticated) {
      auth.signoutRedirect().catch(() => {
        // Fallback if signout fails
        routeToLogin();
      });
    } else {
      routeToLogin();
    }
  }

  return (
    <>
      <Tooltip title="Help Guide">
        <IconButton onClick={openGuide} aria-label='Help'>
          <QuestionMark fontSize="medium" sx={{color: 'white'}} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Log out">
        <IconButton onClick={logout} aria-label='Account'>
          <PowerSettingsNew fontSize="medium" sx={{color: 'white'}} />
        </IconButton>
      </Tooltip>
    </>
  );
}

export default AccountMenu
